<umkt-card-wrapper [title]="'pages.installAddressCard.title' | i18n"
    [icon]="{ name: 'localizacao', type: 'mondrian-icons' }" [showCheck]="isFormValid"
    [loading]="(isLoading$ | async) ?? false" [initiallyOpen]="true">
    <section class="install-address-card address-data-container">
        <span class="subtitle" *ngIf="isEditing && !isLastStep">{{ 'pages.installAddressCard.subtitle' | i18n }}</span>
        <div *ngIf="userInformation$ | async as userInformation">
            <!-- Estado de visualização -->
            <div *ngIf="!isEditing" class="pi-container">
                <div class="address-complement-row">
                    <div class="field address-container">
                        <div class="address-content">
                            <div class="pi-config-header">
                                <div class="address-info">
                                    <div>
                                        <dt>{{ 'pages.installAddressCard.address' | i18n }}</dt>
                                        <dd *ngIf="userWithInstallAddress?.installAddress as addr">
                                            {{ addr.address }}<ng-container *ngIf="addr.number">, {{ addr.number
                                                }}</ng-container><ng-container *ngIf="addr.neighborhood"> - {{
                                                addr.neighborhood
                                                }}</ng-container>
                                            <br>
                                            <ng-container *ngIf="addr.city && addr.state">{{ addr.city }}/{{ addr.state
                                                }}</ng-container><ng-container *ngIf="addr.zipCode"> - CEP: {{
                                                formatZipCode(addr.zipCode) }}</ng-container>
                                        </dd>
                                    </div>

                                    <div class="complement-cell"
                                        *ngIf="getDisplayComplement()">
                                        <div class="field-cell">
                                            <dt>{{ 'pages.installAddressCard.complement' | i18n }}</dt>
                                            <dd>{{ getDisplayComplement() }}</dd>
                                        </div>
                                    </div>
                                    <div class="reference-installation"
                                        *ngIf="getDisplayReference()">
                                        <div class="field-cell">
                                            <dt>{{ 'pages.installAddressCard.reference' | i18n }}</dt>
                                            <dd>{{ getDisplayReference() }}</dd>
                                        </div>
                                    </div>
                                </div>
                                <div class="pi-actions" *ngIf="isLastStep">
                                    <button type="button" class="pi-edit-btn" (click)="editAddress()">{{
                                        'pages.installAddressCard.editButton' | i18n }}</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            <!-- Estado de edição -->
            <form *ngIf="isEditing" [formGroup]="addressForm" class="">
                <div class="warning-changes warning-changes--full" *ngIf="!loadingHps && hpsOptions.length > 0">
                    <span class="warning-text">{{ 'pages.installAddressCard.subjectToChange' | i18n }}</span>
                </div>
                <div class="no-complement-message" *ngIf="!loadingHps && hpsOptions.length === 0">
                    <span class="no-complement-text">{{ 'pages.installAddressCard.noComplementAvailable' | i18n
                        }}</span>
                </div>

                <div class="address-complement-row">
                    <div class="field address-container">
                        <div class="address-content">
                            <dt>{{ 'pages.installAddressCard.address' | i18n }}</dt>
                            <dd *ngIf="userWithInstallAddress?.installAddress as addr">
                                {{ addr.address }}<ng-container *ngIf="addr.number">, {{ addr.number
                                    }}</ng-container><ng-container *ngIf="addr.neighborhood"> - {{ addr.neighborhood
                                    }}</ng-container>
                                <br>
                                <ng-container *ngIf="addr.city && addr.state">{{ addr.city }}/{{ addr.state
                                    }}</ng-container><ng-container *ngIf="addr.zipCode"> - CEP: {{
                                    formatZipCode(addr.zipCode) }}</ng-container>
                            </dd>
                        </div>
                        <div class="change-address" (click)="openLocationModal()">
                            {{ 'pages.installAddressCard.change' | i18n }}
                        </div>
                    </div>
                </div>

                <div class="complement-cell">
                    <div class="complement-loading-wrapper" *ngIf="loadingHps">
                        <umkt-loading [isLoading]="true" [showText]="true"
                            [text]="'pages.installAddressCard.loadingComplements' | i18n" size="md" mode="contained">
                        </umkt-loading>
                    </div>
                    <div class="complement-select-wrapper" *ngIf="!loadingHps"
                        [class.complement-select-wrapper--hidden]="hpsOptions.length === 0">
                        <select class="complement-select" [value]="selectedComplementOption"
                            *ngIf="hpsOptions.length > 0"
                            (change)="onComplementOptionChange($any($event.target).value)">
                            <option value="" [selected]="!selectedComplementOption">{{
                                'pages.installAddressCard.selectComplement' | i18n }}</option>
                            <option *ngFor="let item of hpsOptions" [value]="item.complement"
                                [selected]="item.complement === selectedComplementOption">{{ item.complement }}
                            </option>
                        </select>
                    </div>
                    <div class="input-group complement-input-group--hidden"
                        *ngIf="!loadingHps && hpsOptions.length === 0">
                        <ustore-input #complementInput [placeholder]="'pages.installAddressCard.complement' | i18n"
                            required formControlName="complement" [clearable]="false"></ustore-input>
                    </div>
                </div>

                <div class="reference-installation">
                    <div class="input-group input-group--full">
                        <ustore-input [placeholder]="'pages.installAddressCard.reference' | i18n"
                            formControlName="reference" [clearable]="false"></ustore-input>
                    </div>
                </div>
            </form>
        </div>

        <!-- Botões de ação (apenas quando está editando) -->
        <div class="address-card-actions" *ngIf="isEditing">
            <button class="btn-outline" *ngIf="isLastStep; else backButton" (click)="cancelEdit()">
                {{ 'shared.buttons.cancel' | i18n }}
            </button>
            <ng-template #backButton>
                <button class="btn-outline" (click)="previousStep.emit()">{{ 'shared.buttons.back' | i18n }}</button>
            </ng-template>
            <button class="btn-primary" (click)="saveAndContinue()" [disabled]="!addressForm.valid">
                {{ (isLastStep ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
            </button>
        </div>
    </section>
</umkt-card-wrapper>

<!-- Modal de Localização -->
<umkt-location-modal [isOpen]="isLocationModalOpen" [mandatory]="false" (modalClose)="closeLocationModal()"
    (locationConfirm)="onLocationConfirm($event)"></umkt-location-modal>